import React, { useEffect, useCallback, useState} from 'react';
import Golden from "components/landing/golden/Golden.js";
import {connect} from 'react-redux';

const LandingPart4 = ({part}) => { 
    return (
        <div ref={part} className="landing-part part-4">
          <div className="mission-subheader left">
            Crypto-native from the start.
          </div>
          <div className="crypto-row">
          <Golden elements={[
              <div className="open-source">
                <span>Open-Source</span>
                <div className="diagonal"/>
                <div className="open-protocol">Open-Protocol</div>
              </div>,
              <div className="on-chain">
                Zequencer stores all creative metadata on the blockchain.
                Storing this on-chain ensures that all attribution and crediting is never lost.
              </div>,
              <div className="nft">
                <div className="txt">Mint NFTs</div>
                <div className="nft-circle"/>
                <div className="coming-soon">Coming soon</div>
              </div>,
              <div className="splits">
                <span>Splits</span>
                <div className="coming-soon">Coming soon</div>
              </div>,
              <div className="sp404"></div>,
              <div className="sp404"></div>,
              <div className="sp404"></div>,
          ]}/>
            <div className="diagrams">
              <div className="box-1">
                Encrypted Groups
              </div>
              <div className="box-2">
                Token Gated
                <div className="coming-soon">Coming soon</div>
              </div>
              <div className="box-3"/>
            </div>
          </div>
          <div className="more-crypto">
            <p>
              The <i>group</i> is a core primitive in Zequencer. <br/>
              A <i>group</i> of creatives can keep their shared library private to just the group.
            </p>
            <p>
              The <i>group</i> can decide who gets to join, and the terms of membership.
            </p>
            <p>
              Coming Soon: <i>Groups</i> will be able to mint NFTs of their collective works, with the
              profits split among contributers&#8211; including sample-makers. 
            </p>
          </div>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LandingPart4);
